<div [@search]="searchState">
    <mat-form-field class="search_field" appearance="outline">
        <mat-icon class="toolbar_icon_color">search</mat-icon>
        <input
            autocomplete="off"
            [formControl]="searchCtrl"
            matInput
            placeholder="{{ searchPlaceholder || 'Search' }}"
            #search="matInput" />
        <mat-icon matSuffix (click)="toggleSearchBox()" class="search__icon"
            >cancel</mat-icon
        >
    </mat-form-field>
</div>
<button
    matTooltip="Search"
    matTooltipClass="redClass"
    matTooltipPosition="above"
    mat-icon-button
    class="toolbar_icon_color search-btn"
    (click)="toggleSearchBox()"
    *ngIf="searchState == 'default'">
    <mat-icon class="toolbar_icon_color">search</mat-icon>
</button>
